import Vue 				from 'vue';
import Router			from 'vue-router';

import Index			from '~/views/Index.vue';
import Admin			from '~/views/original/Admin.vue';
import ForgetPassword	from '~/views/original/ForgetPassword.vue';
import Menu				from '~/views/original/Menu.vue';
import Login			from '~/views/original/Login.vue';
import Logout			from '~/views/original/Logout.vue';
import Point			from '~/views/original/Point.vue';
import Profile			from '~/views/original/Profile.vue';
import ResetPassword	from '~/views/original/ResetPassword.vue';
import Recruit			from '~/views/original/Recruit.vue';
import Sales			from '~/views/original/Sales.vue';
import SecurityQuestion	from '~/views/original/SecurityQuestion.vue';
import SignUp			from '~/views/original/SignUp.vue';
import Timeline			from '~/views/original/Timeline.vue';
import Training			from '~/views/original/Training.vue';
import Unauthorized		from '~/views/original/Unauthorized.vue';
	
Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{ path: '/', 												name: 'index', 				component: Index },
		{ path: '/page/:pageName/type/:pageType',					name: 'page',				component: Index },
		{ path: '/admin',											name: 'admin',				component: Admin },
		{ path: '/admin/:operationType',							name: 'adminOperationType',	component: Admin },
		{ path: '/admin/:operationType/operation/:operationName',	name: 'adminOperationName',	component: Admin },
		{ path: '/forget-password',									name: 'forgetPassword',		component: ForgetPassword },
		{ path: '/login',											name: 'login',				component: Login },
		{ path: '/logout',											name: 'logout',				component: Logout },
		{ path: '/menu',											name: 'menu',				component: Menu },
		{ path: '/point',											name: 'point',				component: Point },
		{ path: '/profile',											name: 'profile',			component: Profile },
		{ path: '/reset-password',									name: 'resetPassword',		component: ResetPassword },
		{ path: '/recruit',											name: 'recruit',			component: Recruit },
		{ path: '/recruit/:recruitmentId',							name: 'recruitRecruitment',	component: Recruit },
		{ path: '/recruit/:recruitmentId/schedule/:scheduleId',		name: 'recruitSchedule',	component: Recruit },
		{ path: '/sales',											name: 'sales',				component: Sales },
		{ path: '/sales/:merchantId/products',						name: 'salesMerchant',		component: Sales },
		{ path: '/sales/:merchantId/input',							name: 'salesInput',			component: Sales },
		{ path: '/security-question',								name: 'securityQuestion',	component: SecurityQuestion },
		{ path: '/sign-up',											name: 'signUp',				component: SignUp },
		{ path: '/timeline',										name: 'timeline',			component: Timeline },
		{ path: '/timeline/refresh',								name: 'timelineRefresh',	component: Timeline },
		{ path: '/training',										name: 'training',			component: Training },
		{ path: '/training/:courseCode',							name: 'trainingCourse',		component: Training },
		{ path: '/training/:courseCode/module/:moduleCode',			name: 'trainingModule',		component: Training },
		{ path: '/unauthorized',									name: 'unauthorized',		component: Unauthorized }
	]
})
